import styled from 'styled-components';

export const SignInForCheckInStyles = styled.div`
    @media screen and (max-width: 600px) {
      .form-container {
        margin-left: 0 !important;
      }
    }
`
